import React from 'react'
import cn from 'classnames'
import { withStyles } from '@material-ui/core/styles'
import SvgIcon from '@material-ui/core/SvgIcon'

const style = {
  root: {
    width: '25px',
    height: '20px',
  },
}

const RadiusIcon = ({ classes, className, ...props }) => (
  <SvgIcon
    {...props}
    className={cn(classes.root, className)}
    fill="none"
    viewBox="0 0 25 24"
  >
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12.4883" cy="12.498" r="10" stroke="#808080" />
      <path
        d="M23.7875 12.498C23.7875 13.1056 23.295 13.598 22.6875 13.598C22.08 13.598 21.5875 13.1056 21.5875 12.498C21.5875 11.8905 22.08 11.398 22.6875 11.398C23.295 11.398 23.7875 11.8905 23.7875 12.498Z"
        fill="white"
        stroke="#808080"
        stroke-width="0.8"
      />
      <path
        d="M3.58828 12.498C3.58828 13.1056 3.09579 13.598 2.48828 13.598C1.88077 13.598 1.38828 13.1056 1.38828 12.498C1.38828 11.8905 1.88077 11.398 2.48828 11.398C3.09579 11.398 3.58828 11.8905 3.58828 12.498Z"
        fill="white"
        stroke="#808080"
        stroke-width="0.8"
      />
      <path
        d="M13.7875 2.49805C13.7875 3.10556 13.295 3.59805 12.6875 3.59805C12.08 3.59805 11.5875 3.10556 11.5875 2.49805C11.5875 1.89053 12.08 1.39805 12.6875 1.39805C13.295 1.39805 13.7875 1.89053 13.7875 2.49805Z"
        fill="white"
        stroke="#808080"
        stroke-width="0.8"
      />
      <path
        d="M13.7875 22.498C13.7875 23.1056 13.295 23.598 12.6875 23.598C12.08 23.598 11.5875 23.1056 11.5875 22.498C11.5875 21.8905 12.08 21.398 12.6875 21.398C13.295 21.398 13.7875 21.8905 13.7875 22.498Z"
        fill="white"
        stroke="#808080"
        stroke-width="0.8"
      />
    </svg>
  </SvgIcon>
)

export default withStyles(style)(RadiusIcon)
